<!--
 * @Description: 足迹
 * @version: 1.0.0
 * @Author: FJW
 * @Date: 2024-09-24 10:22:29
 * @LastEditors: FJW
 * @LastEditTime: 2024-12-03 17:02:59
-->
<template>
  <div>
    <!-- 搜索框 -->
    <!-- <div style="text-align: left;padding-right: 20px;" class="flex flex-bet">
      <el-input placeholder="请输入商品名称" size="small" v-model="storeName" @keyup.enter.native="getPageSearch" />
      <el-button icon="el-icon-search" @click="getPageSearch" style="margin-left: 30px;">搜索</el-button>
    </div> -->
    <!-- 主体 -->
    <div style="text-align: left;font-size: 14px;color:#808080" v-if="tableData.length===0">暂无足迹</div>
    <div style="margin-top: 10px;overflow-y: overlay;" v-el-height v-else>
      <div v-for="item in tableData" :key="item.id" class="item_class flex flex-align-center">
        <div class="item_image flexShrink0" style="width: 110px;height: 110px;position: relative;">
          <img :src="item.image" alt="" style="width:100%;height: 100%;">
          <div style="position:absolute;bottom: 0;left: 50%; transform:translateX(-50%);text-align: center; padding: 2px 10px;background-color: #808080;color:#fff;opacity: 0.7;">
            <span style="white-space:nowrap">{{formatTimeDifference($dayjs(item.createTime))}}</span>
          </div>
        </div>
        <div style="margin-left: 20px;text-align: left;font-size: 16px;">
          <div class="ellipsis" style="width: 180px;color:#66b1ff;cursor: pointer;" :title="item.storeName" @click="routerToProductDetail(item)">{{item.storeName}}</div>
          <div class="flex flex-align-center">
            <div style="color: #ff602d;">￥{{item.price}}</div>
            <div style="color: #999;margin-left: 20px;">销量{{item.sales}}</div>
          </div>
          <div class="item_baby" @click="setShopDetail(item)">发送宝贝链接</div>
        </div>
      </div>
    </div>
    <!-- 分页组件 -->
    <Pagination :total="totalRecord" :page.sync="pageNo" :limit.sync="pageSize" @getPageChange="getPageChange" v-if="tableData.length>0" />
  </div>
</template>
    
<script>
import { formatTimeDifference } from '@/utils/func.js'
export default {
  data() {
    return {
      totalRecord: 0, // 总数
      pageSize: 50, // 每页条数
      pageNo: 1, // 当前页码
      tableData: [],
      storeName: '',
      kmallUserId: ''
    }
  },
  methods: {
    // 跳转详情
    routerToProductDetail(data) {
      const params = {
        type: data.type,
        id: data.productId
      }
      const queryString = new URLSearchParams(params).toString()
      const targetUrl = `${process.env.VUE_APP_SHOP_BASE_URL}/#/mall/product/form?${queryString}`;
      window.open(targetUrl, '_blank', 'width=1780,height=720,top=50, left=50')
    },

    // 发送商品详情
    setShopDetail(item) {
      this.$emit('sendRichTextMessage', item)
    },

    // 修改页数
    getPageChange(page) {
      this.pageSize = page.limit
      this.pageNo = page.page
      this.getHistoryDetail()
    },

    getPageSearch() {
      this.pageNo = 1
      this.getHistoryDetail()
    },

    // 足迹
    getHistoryDetail() {
      const queryParams = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        isShow: 1,
        stock: 1,
        cateId: 0,
        storeName: this.storeName,
        type: 'foot',
        nickname: this.nickname,
        uid: this.kmallUserId
      }
      this.$httpShop({
        url: '/product/store-product-relation/page',
        method: 'get',
        params: queryParams
      }).then((res) => {
        this.$isLoading.close()
        this.tableData = res.data.list
        this.totalRecord = res.data.total
      })
    },

    formatTimeDifference
  }
}

</script>
<style rel='stylesheet/scss' lang='scss' scoped>
.item_class {
  background-color: #fff;
  margin-bottom: 20px;
  margin-right: 20px;
  border-radius: 10px;
  .item_image {
    width: 110px;
    height: 110px;
  }
  .item_baby {
    border: 1px solid #3d7fff;
    border-radius: 2px;
    color: #3d7fff;
    cursor: pointer;
    font-size: 10px;
    margin-top: 5px;
    text-align: center;
    width: 82px;
    padding: 3px 7px;
  }
}
</style>